import LoadingIcon from "@components/LoadingIcon";
import { Box, Card, Stack, Divider, Typography } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  title: string;
  noResultsMessage?: string;
  isLoading: boolean;
  children: ReactNode;
  noResults?: boolean;
}

const ListBox = ({
  title,
  noResultsMessage,
  isLoading,
  children,
  noResults,
}: Props) => {
  const showCard = !noResults && !isLoading;
  const showNoResultsOrLoading = (noResults && noResultsMessage) || isLoading;
  return (
    <>
      {showNoResultsOrLoading && (
        <Box sx={{ padding: 2, textAlign: "center", height: 50 }}>
          {noResultsMessage && !isLoading && (
            <Typography variant="subtitle2">{noResultsMessage}</Typography>
          )}
          {isLoading && <LoadingIcon />}
        </Box>
      )}
      {showCard && (
        <Card
          variant="outlined"
          sx={{ display: "flex", flexDirection: "column", height: 1 }}
        >
          <Typography variant="subtitle1" sx={{ paddingX: 2, paddingY: 1 }}>
            {title}
          </Typography>
          <Divider />
          <Stack
            divider={<Divider />}
            sx={{
              overflowY: "auto",
              height: 1,
            }}
          >
            {children}
          </Stack>
        </Card>
      )}
    </>
  );
};

export default ListBox;
